<mat-card>
    <kendo-grid
        [navigable]="true"
        [data]="query | async"
        [loading]="isLoading"
        [skip]="state.skip"
        [pageSize]="state.take"
        [sort]="sort"
        [sortable]="sortSettings"
        (sortChange)="sortChange($event)"
        scrollable="virtual"
        [rowHeight]="36"
        [height]="750"
        (pageChange)="pageChange($event)"
        (excelExport)="onExcelExport($event)"
    >

        <ng-template kendoGridToolbarTemplate>
            <button class="export-to-excel-button" kendoGridExcelCommand>
                <img
                    class="ms-icon"
                    src="assets/icons/excel-icon.svg"
                    style="width: 35px;
                            height: 35px;
                            vertical-align: middle;">
                    {{ 'ExportToExcel' | translate: {Default: "Export to Excel"} }}
            </button>

            <div class="filters-container" *ngIf="!loadingPositions">
                <filter-control [categories]="filterCategories" (callback)="filterCallback($event)"></filter-control>
            </div>
        </ng-template>

        <kendo-grid-column
            *ngFor="let col of employeeColumns"
            [field]="col.field"
            [title]="col.title"
            [width]="300"
        ></kendo-grid-column>

        <kendo-grid-column
            *ngFor="let col of employmentRecordColumns"
            [field]="col.field"
            [title]="col.title"
            [width]="300"
        ></kendo-grid-column>

        <kendo-grid-column
            *ngFor="let col of bankDetailColumns"
            [field]="col.field"
            [title]="col.title"
            [width]="300"
        ></kendo-grid-column>

        <kendo-grid-excel
            fileName="EmployeeBankDetailsReport.xlsx"
            [fetchData]="allData"
        ></kendo-grid-excel>
    </kendo-grid>
</mat-card>

